import { Checkbox } from '@thoughtspot/radiant-react/widgets/checkbox';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
export const CheckboxFormComponent = ({ label, elementKey, onChange, selectedValue, defaultValue, isDisabled = false, }) => {
    const checkedValue = selectedValue ?? defaultValue;
    const onChangeCheckbox = (e) => {
        onChange(elementKey, e.target.checked);
    };
    return (React.createElement(FormControl, { label: "", className: styles.formComponentItemCheckBox, noMarginBottom: true, "data-testid": `test-id-${elementKey}` },
        React.createElement(Checkbox, { id: "checkboxFormComponent", label: label, checked: checkedValue, key: elementKey, onChange: onChangeCheckbox, disabled: isDisabled })));
};
//# sourceMappingURL=checkbox-form.component.js.map